import type {Department, Rec} from 'src/typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {transferify} from 'shared/utils/data-service-utils';

export interface ReportReferenceReported {
    totalHours: number;
}

export class SutorReportsProcessingDataService {
    public static serviceName = 'sutorReportsProcessingDataService';

    private static readonly TOTAL_REPORTED_ROUTE = 'report-references/total-reported';
    private static readonly SHARABLE_DEPARTMENTS_ROUTE = 'report-references/sharable-departments';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getTotalReported(reportReference: Rec): Promise<ReportReferenceReported> {
        return this.ajaxService
            .createRequest(SutorReportsProcessingDataService.TOTAL_REPORTED_ROUTE)
            .get(transferify({reportReference}));
    }

    public async getSharableDepartments(): Promise<Department[]> {
        return this.ajaxService
            .createRequest(SutorReportsProcessingDataService.SHARABLE_DEPARTMENTS_ROUTE)
            .get();
    }
}